import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuardService as AuthGuard } from './services/auth/auth-guard.service';

import { rellenarMenUsuario, rellenarMenuAdmin } from './config/procedimientos_registros';

import { informes } from './config/models';
import { MiPerfilComponent } from './pages/mi-perfil/mi-perfil.component';


const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    { path: 'login', component: LoginComponent },
    {
        path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: { titulo: 'Inicio' },
        children: [
            { path: 'inicio', redirectTo: '/dashboard', data: { titulo: 'Inicio' } },
            {
                path: 'usuarios',
                loadChildren: () => import('./pages/usuarios/app.usuario.modules').then(m => m.UsuarioModule),
                data: { titulo: 'Usuarios' }
            },
            {
                path: 'perfil',
                component: MiPerfilComponent,
                canActivate: [AuthGuard],
                data: { titulo: 'Mi perfil'}
            },
            {
                path: 'consultas',
                loadChildren: () => import('./pages/consultas-log/app.consultas-log.module').then(m => m.ConsultasLogModule),
                data: { titulo: 'Historial de acceso' }
            },
            {
                path: 'articulos',
                loadChildren: () => import('./pages/articulos/app.articulos.module').then(m => m.AppArticulosModule),
                data: {titulo: 'Artículos'}
            },
            {
                path: 'packs',
                loadChildren: () => import('./pages/packs/app.packs.module').then(m => m.AppPacksModule),
                data: {titulo: 'Packs'}
            },
            {
                path: 'proveedores',
                loadChildren: () => import('./pages/proveedores/app.proveedores.module').then(m => m.AppProveedoresModule),
                data: {titulo: 'Proveedores'}
            },
            {
                path: 'clientes',
                loadChildren: () => import('./pages/clientes/app.clientes.module').then(m => m.AppClientesModule),
                data: {titulo: 'Clientes'}
            },
            {
                path: 'ofertas',
                loadChildren: () => import('./pages/ofertas/app.ofertas.module').then(m => m.AppOfertasModule),
                data: {titulo: 'Ofertas'}
            } ,    
            {
                path: 'ofertas_packs',
                loadChildren: () => import('./pages/ofertas-packs/app.ofertas-packs.module').then(m => m.AppOfertasPacksModule),
                data: {titulo: 'Ofertas Packs'}
            },    
            {
                path: 'articulos_proveedor',
                loadChildren: () => import('./pages/articulos-proveedor/app.articulos.module').then(m => m.AppArticulosModule),
                data: {titulo: 'Articulos proveedores'}
            }     
        ],
    },
    // {
    //     path: 'perfil',
    //     component: MiPerfilComponent,
    //     canActivate: [AuthGuard],
    //     data: { titulo: 'Mi perfil'}
    // },
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
    },

    { path: '**', redirectTo: 'login' },
];

let auxMenu = rellenarMenuAdmin();
let auxMenuUsuatio = rellenarMenUsuario();

for (let index = 0; index < routes.length; index++) {
    const element = routes[index];


    if (element.path.localeCompare('dashboard') == 0) {
        // console.log('element', element);
        for (let index1 = 0; index1 < element.children.length; index1++) {
            const path = element.children[index1].path;
            // console.log('path', path);
            let auxData: informes = auxMenu.find((ruta) => {
                // console.log('ruta', (ruta.id as string).localeCompare('lavadora') == 0 );
                if (ruta.id.localeCompare(path) == 0) {

                    element.children[index1].data = { titulo: ruta.text || '', id: ruta.id }
                    return ruta;

                }

            });


        }
    }

}

@NgModule({
    imports: [RouterModule.forRoot(routes,{ preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
